import React from "react";
import { ArrowLeft, FileText } from "lucide-react";
import type { SessionArtifact } from "./SessionStudioPanel";
import { renderMarkdown } from "utils/renderMarkdown";

interface Props {
  artifact: SessionArtifact;
  onBack: () => void;
}

export const ArtifactViewerPanel: React.FC<Props> = ({ artifact, onBack }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white px-4 pt-3 pb-2.5 border-b border-slate-100">
        <div className="flex items-center gap-2">
          <button
            onClick={onBack}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              padding: "3px 8px",
              background: "#f1f5f9",
              border: "1px solid #e2e8f0",
              borderRadius: 6,
              cursor: "pointer",
              fontSize: 11,
              color: "#475569",
            }}
          >
            <ArrowLeft style={{ width: 12, height: 12 }} />
            Back
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: 6, flex: 1, minWidth: 0 }}>
            <FileText style={{ width: 13, height: 13, color: "#2c1561", flexShrink: 0 }} />
            <span
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#0f172a",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {artifact.title}
            </span>
          </div>
        </div>
        {artifact.source && (
          <p style={{ fontSize: 10, color: "#94a3b8", margin: "4px 0 0 28px" }}>
            {artifact.source}
          </p>
        )}
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px" }}>
        {renderMarkdown(artifact.content, { context: "studio" })}
      </div>
    </div>
  );
};
